/*
------------------------------------------------------------------
Author: TAMARAGENCY
Author URL: https://tamaragency.com
Note: To make any CSS change, please use custom.css file. Also, use the root variables of the theme and to add colors, fonts or any other useful variables.
------------------------------------------------------------------
*/

document.addEventListener("DOMContentLoaded", function() {
  
  /* -------------------- Videos Multicolumn -------------------- */
  var multicolumnVideos = document.querySelectorAll('.how-to-use__card__video video');
  var playIcons = document.querySelectorAll('.play__icon');
  
  // Détection de Safari
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  // Force le redraw de chaque élément sur Safari
  if (isSafari) {
    const elements = document.querySelectorAll('.how-to-use__card__imgWrap');
    elements.forEach(function(el) {
      el.style.display = 'none';
      void el.offsetHeight; 
      el.style.display = '';
    });
  }
  
  // Stop toutes les vidéos
  function stopAllVideos() {
    for (var i = 0; i < multicolumnVideos.length; i++) {
      multicolumnVideos[i].pause();
      multicolumnVideos[i].controls = false;
      multicolumnVideos[i].closest('.how-to-use__card__video').classList.remove('lecture');
    }
  }
  
  // Gérer la vidéo
  function handleVideo(video) {
    var videoContainer = video.closest('.how-to-use__card__video');
    
    // Si la vidéo est en cours de lecture, on la met en pause
    if (!video.paused) {
      video.pause();
      video.controls = false;
      videoContainer.classList.remove('lecture');
    } else {
      // Sinon, on arrête toutes les vidéos et on joue celle-ci
      stopAllVideos();
      
      var playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.then(function() {
          // Ne pas afficher les contrôles sur Safari
          if (!isSafari) {
            video.controls = true;
          }
          videoContainer.classList.add('lecture');
        }).catch(function(error) {
          console.error('Erreur de lecture:', error);
        });
      } else {
        // Ne pas afficher les contrôles sur Safari
        if (!isSafari) {
          video.controls = true;
        }
        videoContainer.classList.add('lecture');
      }
    }
  }
  
  // Écouter les événements de pause sur toutes les vidéos
  for (var i = 0; i < multicolumnVideos.length; i++) {
    // Quand la vidéo est mise en pause
    multicolumnVideos[i].addEventListener('pause', function(event) {
      var video = event.target;
      video.controls = false;
      video.closest('.how-to-use__card__video').classList.remove('lecture');
    });
    
    // Quand on clique sur la vidéo
    multicolumnVideos[i].addEventListener('click', function(event) {
      event.preventDefault();
      handleVideo(event.currentTarget);
    });
    
    // Pour Safari, ajouter un écouteur pour l'événement play
    if (isSafari) {
      multicolumnVideos[i].addEventListener('play', function(event) {
        // S'assurer que les contrôles restent désactivés sur Safari
        setTimeout(function() {
          event.target.controls = false;
        }, 0);
      });
    }
  }
  
  // Gérer les clics sur les icônes play
  for (var i = 0; i < playIcons.length; i++) {
    playIcons[i].addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      var video = event.currentTarget.closest('.how-to-use__card__video').querySelector('video');
      handleVideo(video);
    });
  }
});